<template>
  <div class="p-6">

    <a-form layout="inline" :form="form" class="form-label-4">
      <a-form-item label="项目">
        <a-select-pro
          class="form-control"
          v-decorator="['projectCode']"
          placeholder="请选择"
          allowClear
          showSearch
          :options="projectList" @change="prjectChange" :dropdownMatchSelectWidth="false"></a-select-pro>
      </a-form-item>
      <a-form-item label="班组">
        <a-select-pro
          class="form-control"
          v-decorator="['leaderId']"
          placeholder="请选择"
          allowClear
          showSearch
          :options="leaderList" @change="leaderChange"></a-select-pro>
      </a-form-item>
      <div class="warning-text-inline">
        特别说明：1、本报表为截止上一日的数据，未包含当天发起流程数据
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        2、查询工人数据时请选择项目，班组筛选条件
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        3、有讨薪记录的工人背景色突出标记显示: 讨薪决策要支付工人红色背景、讨薪决策不支付工人橙色背景
      </div>
    </a-form>

    <br />

    <div class="info-box">
      <div class="info-item">
        <div class="info-title">姓名：</div>
        <div class="info-content">{{ detailData.username }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">当前项目：</div>
        <div class="info-content">{{ detailData.projectName }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">身份证：</div>
        <div class="info-content">{{ detailData.cardNumber }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">当前班组：</div>
        <div class="info-content">{{ detailData.leaderName }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">年龄：</div>
        <div class="info-content">{{ detailData.age }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">当前类别：</div>
        <div class="info-content">{{ detailData.workerKind }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">籍贯：</div>
        <div class="info-content">{{ detailData.nativePlace }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">当前工种：</div>
        <div class="info-content">{{ detailData.workerType }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">性别：</div>
        <div class="info-content">{{ detailData.sex }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">当前小工种：</div>
        <div class="info-content">{{ detailData.kindType }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">银行账号：</div>
        <div class="info-content">{{ detailData.bankAcount }}</div>
      </div>
      <div class="info-item">
        <div class="info-title">手机号：</div>
        <div class="info-content">{{ detailData.phone }}</div>
      </div>
    </div>
    <h3 class="mt-6">工作履历</h3>
    <div>
      <a-table
        rowKey="id"
        bordered
        :columns="tableColumns"
        :dataSource="dataSource"
        :pagination="false"
        size="small"
        :customRow="customRow"
        :rowHoverable="false"></a-table>
      <table class="text-lg border-collapse" style="width: 70%; margin-top: 10px;">
        <thead>
          <tr>
            <th style="width: 180px; text-align: left; font-weight: normal; font-size: 16px; font-weight: bold;">汇总</th>
            <!-- <th style="width: 150px; text-align: left;">应发金额/元</th> -->
            <th style="width: 200px; text-align: left;">实发金额/元(实付工资+工友借支)</th>
            <!-- <th style="width: 140px; text-align: left;">欠发金额/元</th> -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 180px; white-space: nowrap; text-align: left; font-size: 16px;">合计数据</td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ needAmount }}</span></td> -->
            <td style="text-align: left;"><span class="text-black">{{ actualAmount }}</span></td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ backAmount }}</span></td> -->
          </tr>
          <tr>
            <td style="width: 180px; white-space: nowrap; text-align: left; font-size: 16px;">其中：工资表归档数据</td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ archivedNeedAmount }}</span></td> -->
            <td style="text-align: left;"><span class="text-black">{{ archivedActualAmount }}</span></td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ archivedBackAmount }}</span></td> -->
          </tr>
          <tr>
            <td style="width: 180px; white-space: nowrap; text-align: left; font-size: 16px;">其中：工资表在途数据</td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ transitNeedAmount }}</span></td> -->
            <td style="text-align: left;"><span class="text-black">{{ transitActualAmount }}</span></td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ transitBackAmount }}</span></td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ASelectPro from '@/components/SelectPro.vue'
import { getProjectListByCard, getLeaderListByCard } from '@/service/getData'
export default {
  components: { ASelectPro },
  data() {
    const tableColumns = [
      {
        title: '区域',
        width: 70,
        align: 'center',
        dataIndex: 'areaName',
      },
      {
        title: '项目',
        width: '10%',
        align: 'left',
        dataIndex: 'projectName',
      },
      {
        title: '班组',
        width: '5%',
        align: 'center',
        dataIndex: 'leaderName',
      },
      {
        title: '开始时间-结束时间',
        width: '12%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <span>
              {moment(row.startTime).format('YYYY/MM/DD')}
              {' - '}
              {row.endTime ? moment(row.endTime).format('YYYY/MM/DD') : '暂无'}
            </span>
          )
        },
      },
      {
        title: '工种',
        width: '8%',
        align: 'left',
        dataIndex: 'workerType',
      },

      {
        title: '类别',
        width: '4%',
        align: 'center',
        dataIndex: 'workerKind',
      },
      {
        title: '小类别',
        width: '4%',
        align: 'center',
        dataIndex: 'kindType',
      },
      {
        title: '是否有讨薪',
        width: '5%',
        align: 'center',
        dataIndex: 'isHaveSalary',
        customRender: (text) => {
          return <span style=" font-weight: bold;">{text}</span>
        },
      },
      {
        title: '讨薪日期',
        width: '5%',
        align: 'center',
        dataIndex: 'salaryDate',
        customRender: (text) => {
          return <span style=" font-weight: bold;">{text}</span>
        },
      },
      // {        title: '应发金额/元',        width: '6%',        align: 'center',        dataIndex: 'needAmount',      },
      {
        title: '实发金额/元(实付工资+工友借支)',
        width: '6%',
        align: 'center',
        dataIndex: 'actualAmount',
      },
      // {        title: '欠发金额/元',        width: '6%',        align: 'center',        dataIndex: 'backAmount',      },
      // 归档数据列
      // {
      //   title: '归档应发金额',
      //   width: '5%',
      //   align: 'center',
      //   dataIndex: 'archivedNeedAmount',
      // },
      {
        title: '归档实发金额',
        width: '5%',
        align: 'center',
        dataIndex: 'archivedActualAmount',
      },
      // {
      //   title: '归档欠发金额',
      //   width: '5%',
      //   align: 'center',
      //   dataIndex: 'archivedBackAmount',
      // },
      // 在途数据列
      // {
      //   title: '在途应发金额',
      //   width: '5%',
      //   align: 'center',
      //   dataIndex: 'transitNeedAmount',
      // },
      {
        title: '在途实发金额',
        width: '5%',
        align: 'center',
        dataIndex: 'transitActualAmount',
      },
      // {
      //   title: '在途欠发金额',
      //   width: '5%',
      //   align: 'center',
      //   dataIndex: 'transitBackAmount',
      // },
    ]
    return {
      form: this.$form.createForm(this),
      projectList: [],
      cardId: '',
      leaderList: [],
      selectProjectCode: '',
      selectLeaderId: '',

      detailData: {},
      dataSource: [],
      tableColumns,
      needAmount: 0,
      actualAmount: 0,
      backAmount: 0,

      // 归档数据
      archivedNeedAmount: '',
      archivedActualAmount: '',
      archivedBackAmount: '',

      // 在途数据
      transitNeedAmount: '',
      transitActualAmount: '',
      transitBackAmount: ''
    }
  },
  methods: {
    customRow(record) {
      if (record.isHaveSalary === '是') {
        // 将讨薪金额转换为数字进行比较
        const txAmount = parseFloat(record.txAmount) || 0
        if (txAmount > 0) {
          return {
            style: {
              background: '#f44336',
              color: '#ffffff'
            },
            class: 'red-row',
            // 直接在JS中处理悬停事件
            on: {
              mouseenter: (e) => {
                // 强制保持原样式
                e.currentTarget.style.backgroundColor = '#f44336'
                e.currentTarget.style.color = '#ffffff'
                // 确保所有单元格也保持样式
                const cells = e.currentTarget.querySelectorAll('td')
                cells.forEach(cell => {
                  cell.style.backgroundColor = '#f44336'
                  cell.style.color = '#ffffff'
                })
              },
              mouseleave: (e) => {
                // 离开时也保持原样式
                e.currentTarget.style.backgroundColor = '#f44336'
                e.currentTarget.style.color = '#ffffff'
                // 确保所有单元格也保持样式
                const cells = e.currentTarget.querySelectorAll('td')
                cells.forEach(cell => {
                  cell.style.backgroundColor = '#f44336'
                  cell.style.color = '#ffffff'
                })
              }
            }
          }
        } else if (txAmount === 0) {
          return {
            style: {
              background: '#ff8a65',
              color: '#ffffff'
            },
            class: 'light-red-row',
            // 直接在JS中处理悬停事件
            on: {
              mouseenter: (e) => {
                // 强制保持原样式
                e.currentTarget.style.backgroundColor = '#ff8a65'
                e.currentTarget.style.color = '#ffffff'
                // 确保所有单元格也保持样式
                const cells = e.currentTarget.querySelectorAll('td')
                cells.forEach(cell => {
                  cell.style.backgroundColor = '#ff8a65'
                  cell.style.color = '#ffffff'
                })
              },
              mouseleave: (e) => {
                // 离开时也保持原样式
                e.currentTarget.style.backgroundColor = '#ff8a65'
                e.currentTarget.style.color = '#ffffff'
                // 确保所有单元格也保持样式
                const cells = e.currentTarget.querySelectorAll('td')
                cells.forEach(cell => {
                  cell.style.backgroundColor = '#ff8a65'
                  cell.style.color = '#ffffff'
                })
              }
            }
          }
        }
      }
      return {}
    },
    async prjectChange(value) {
      if (value !== null && value !== undefined && value !== '') {
        this.selectProjectCode = value
      } else {
        this.selectProjectCode = ''
      }
      await this.loadExperience(this.cardId)
    },
    async leaderChange(value) {
      if (value !== null && value !== undefined && value !== '') {
        this.selectLeaderId = value
      } else {
        this.selectLeaderId = ''
      }
      await this.loadExperience(this.cardId)
    },
    async loadExperience(cardId) {
      const res = await this.$axios.post(`/report/evidence/chain/worker/experience/${cardId}-${this.selectProjectCode}-${this.selectLeaderId}`)
      this.dataSource = res.data.list
      this.needAmount = res.data.sum.needAmount
      this.actualAmount = res.data.sum.actualAmount
      this.backAmount = res.data.sum.backAmount

      // 归档数据赋值
      this.archivedNeedAmount = res.data.sum.archivedNeedAmount ?? ''
      this.archivedActualAmount = res.data.sum.archivedActualAmount ?? ''
      this.archivedBackAmount = res.data.sum.archivedBackAmount ?? ''

      // 在途数据赋值
      this.transitNeedAmount = res.data.sum.transitNeedAmount ?? ''
      this.transitActualAmount = res.data.sum.transitActualAmount ?? ''
      this.transitBackAmount = res.data.sum.transitBackAmount ?? ''
    },
    async loadWorkerInfo(param) {
      const res = await this.$axios.post(`/report/evidence/chain/worker/Info`, param)
      this.detailData = res.data
    },
  },
  async mounted() {
    const { cardId, projectCode, leaderId } = this.$route.query
    this.cardId = cardId
    this.projectList = await getProjectListByCard({ cardId })
    this.leaderList = await getLeaderListByCard({ cardId })
    await this.loadWorkerInfo({ cardId, projectCode, leaderId })
    await this.loadExperience(cardId)
  },
}
</script>

<style lang="less" scoped>
.warning-text-inline {
  color: #ff0000;
  font-size: 14px;
  line-height: 1.8;
  padding: 5px 0 0 20px;
  display: inline-block;
  vertical-align: top;
}

.info-box {
  display: grid;
  grid-template-columns: 50% 50%;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;

  .info-item {
    display: flex;
    border: 1px solid #ccc;
    border-right: 0;
    border-bottom: 0;
    height: 40px;

    .info-title {
      flex: 200px 0 0;
      border-right: 1px solid #ccc;
      background: #e5ebff;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 10px;
    }

    .info-content {
      padding-left: 10px;
      flex: 1;
      display: flex;
      align-items: center;
    }
  }
}

/* 简化样式，移除 :global 选择器 */
/* 悬停效果已在 JavaScript 中处理 */
</style>
